module.exports = __webpack_public_path__ + "static/media/stjepan.0c741956.jpg";